import { BaseCrudService } from "@/services/base";
import { Office } from "@/swagger/models";

class OfficeService extends BaseCrudService<Office> {
    constructor() {
        super({
            apiPrefix: "offices",
            entityName: "office",
        });
    }

    build(fields: Partial<Office> & Pick<Office, "customerId">): Office {
        return Object.assign(
            {
                name: "New office",
                address: "",
                postalCode: "",
                city: "",
                province: "",
                country: "",
                opensAt: "09:00+2",
                closesAt: "17:00+2",
                timeZone: "Europe/Amsterdam",
            },
            fields,
        );
    }
}

export const officeService = new OfficeService();
